import router from "./router";
// import store from './store'
// import { Message } from 'element-ui'
import { getSessionStorage } from "@/utils/auth"; // get token from cookie
// import { stopWxShare } from "@/utils/config";

const whiteList = ["/login", "/register", "/word"]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // set page title
  document.title = to.meta.title;

  const hasGetUserInfo =
    (getSessionStorage("info") && JSON.parse(getSessionStorage("info"))) || "";
  // determine whether the user has logged in
  const hasToken = (hasGetUserInfo && hasGetUserInfo.token) || false;

  if (hasToken) {
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next({ path: "/" });
    } else {
      // stopWxShare();
      // const hasGetUserInfo = JSON.parse(getSessionStorage("info")).niceName;
      if (hasGetUserInfo && hasGetUserInfo.niceName) {
        next();
      } else {
        // try {
        //   next();
        // } catch (error) {
        // remove token and go to login page to re-login
        // await store.dispatch('user/resetToken')
        next(`/login`); // ?redirect=${to.path}
        // }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login`); //?redirect=${to.path}
    }
  }
});

// router.afterEach(() => {
// });
